module.exports = __webpack_public_path__ + "static/media/go_beyond-grades.44c1e499.png";